import { useCallback, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { api, date, formatError, money } from "../../lib/api";
import { Modal } from "../../components/Shell";
import { markRefund } from "./RecordsAdmin";

const STAGE_LABEL = { assessment_payment: "Needs assessment payment", retake_locked: "Retake locked", assessment_ready: "Attempt available",
  certificate_payment: "Passed — certificate unpaid", issuing: "Certificate issuing", certified: "Certified" };

const GrantForm = ({ userId, certs, onDone }) => {
  const [certId, setCertId] = useState(certs[0]?.certification_id || "");
  const [note, setNote] = useState("");
  const submit = async (e) => {
    e.preventDefault();
    try { await api.post(`/admin/users/${userId}/grant-attempt`, { certification_id: certId, note }); toast.success("Free attempt granted"); setNote(""); onDone(); }
    catch (err) { toast.error(formatError(err)); }
  };
  return (
    <form className="grant-form" onSubmit={submit} data-testid="grant-attempt-form">
      <select data-testid="grant-cert-select" value={certId} onChange={(e) => setCertId(e.target.value)}>{certs.map((c) => <option key={c.certification_id} value={c.certification_id}>{c.title}</option>)}</select>
      <input data-testid="grant-note-input" placeholder="Reason (e.g. technical issue)" minLength={3} value={note} onChange={(e) => setNote(e.target.value)} required />
      <button className="button primary compact" data-testid="grant-submit-button">Grant free attempt</button>
    </form>
  );
};

export const LearnerDetail = ({ userId, onClose }) => {
  const [d, setD] = useState(null);
  const load = useCallback(() => api.get(`/admin/users/${userId}`).then((r) => setD(r.data)).catch((e) => toast.error(formatError(e))), [userId]);
  useEffect(() => { load(); }, [load]);
  return (
    <Modal open onClose={onClose} title={d ? d.user.name : "Learner"} testId="learner-detail-dialog">
      {!d ? <div className="loading">Loading…</div> : <div className="learner-detail">
        <p className="muted small">{d.user.email} · {d.user.role} · {d.user.google_linked ? "Google" : "Email"} sign-in · joined {date(d.user.created_at)}</p>
        <h3 className="sub-h">Progress</h3>
        {d.progress.map((p) => <div className="mini-stat" key={p.certification_id} data-testid={`learner-progress-${p.certification_id}`}><span>{p.title}</span><b>{STAGE_LABEL[p.stage]}{p.assessment_credits ? ` · ${p.assessment_credits} credit` : ""}</b></div>)}
        <h3 className="sub-h">Grant a free attempt</h3>
        <GrantForm userId={userId} certs={d.progress} onDone={load} />
        <h3 className="sub-h">Payments</h3>
        {!d.orders.length ? <p className="muted small">No orders.</p> : d.orders.map((o) => (
          <div className="mini-stat" key={o.merchant_order_id} data-testid={`learner-order-${o.merchant_order_id}`}><span>{o.kind} · {money(o.amount_minor)} · {date(o.created_at)} · <span className={`pill ${o.status === "paid" ? "published" : o.status === "refunded" ? "failed" : "draft"}`}>{o.status}</span></span>
            {o.status === "paid" && <button className="button outline compact" data-testid={`learner-refund-${o.merchant_order_id}`} onClick={() => markRefund(o.merchant_order_id, load)}>Mark refunded</button>}</div>))}
        {!!d.grants.length && <><h3 className="sub-h">Granted attempts</h3>{d.grants.map((g) => <div className="mini-stat" key={g.order_id}><span>{g.note} · by {g.granted_by}</span><b>{g.used ? "used" : "unused"}</b></div>)}</>}
        <h3 className="sub-h">Attempts</h3>
        {!d.attempts.length ? <p className="muted small">No attempts.</p> : d.attempts.map((a) => <div className="mini-stat" key={a.id}><span>{a.certification_title} · {date(a.submitted_at)}</span><b>{a.score}% · {a.passed ? "passed" : a.timed_out ? "timed out" : "not passed"}</b></div>)}
        <h3 className="sub-h">Certificates</h3>
        {!d.certificates.length ? <p className="muted small">None.</p> : d.certificates.map((c) => <div className="mini-stat" key={c.certificate_id}><Link className="text-link" to={`/certificate/${c.certificate_id}`}>{c.certificate_id}</Link><b>{c.status}</b></div>)}
      </div>}
    </Modal>
  );
};
